module.exports = __webpack_public_path__ + "static/media/ProfileStep2.c3d5a7bd.svg";